import React, { FC } from 'react';
import s from './WixLogo.scss';

export const WixLogo: FC<{ dataHook?: string }> = ({ dataHook }) => (
  <a data-hook={dataHook} href="/" className={s.logo}>
    <span style={{ opacity: 0 }}>wix.com</span>
  </a>
);
